import {
	WebGLRenderer,
	PCFSoftShadowMap,
	LinearToneMapping,
	VSMShadowMap
} from 'three';

export default class RenderController {
	constructor(canvas, isMobile) {
		// Create Renderer
		this.RENDERER = new WebGLRenderer({
			canvas,
			antialias: true
		});

		this.RENDERER.physicallyCorrectLights = true;
		this.RENDERER.toneMapping = LinearToneMapping;
		this.RENDERER.setPixelRatio(window.devicePixelRatio);
		this.RENDERER.toneMappingExposure = 1.0;

		if (!isMobile) {
			this.RENDERER.shadowMap.enabled = true;
			this.RENDERER.shadowMap.type = VSMShadowMap;
		}

		// Enable Shadows
		// this.RENDERER.shadowMap.enabled = true;
		// this.RENDERER.shadowMap.type = PCFSoftShadowMap;
		// this.RENDERER.shadowMap.width = 2048;
		// this.RENDERER.shadowMap.height = 2048;

		// Set Clear colour
		this.RENDERER.setClearColor(0xffffff, 1);
	}

	// ____________________________________________________________________ Render

	render(scene, camera) {
		this.RENDERER.render(scene, camera);
	}

	// ______________________________________________________________________ Size

	setSize(width, height) {
		// 3rd parameter false to stop this resizing the canvas
		this.RENDERER.setSize(width, height, false);
	}

	setFromJSON(json) {
		if (json.toneMapping) {
			this.RENDERER.toneMapping = json.toneMapping;
		}

		if (json.shadowMapType) {
			this.RENDERER.shadowMap.type = json.shadowMapType;
		}
	}
}
